import { z } from "zod";

// t("COMPLETED")
// t("CREATED")
export const taskStatusEnum = z.enum(["CREATED", "COMPLETED"]);

export type TaskStatus = z.infer<typeof taskStatusEnum>;
